import {NgModule} from '@angular/core';
import {DiscountManagementComponent} from './discount-management.component';
import {CreateDiscountDialogComponent} from './create-discount-dialog/create-discount-dialog.component';
import {DiscountManagementRoutingModule} from './discount-management-routing.module';
import {SharedModule} from '../../shared/shared.module';
import {AffiliateDetailsDialogComponent} from './affiliate-details-dialog/affiliate-details-dialog.component';
import {GetDiscountDialogComponent} from './get-discount-dialog/get-discount-dialog.component';
import {ShopifySyncDialogComponent} from './shopify-sync-dialog/shopify-sync-dialog.component';
import {ShopifyAuditLogDialogComponent} from './shopify-audit-log-dialog/shopify-audit-log-dialog.component';


@NgModule({
  declarations: [
    DiscountManagementComponent,
    CreateDiscountDialogComponent,
    AffiliateDetailsDialogComponent,
    GetDiscountDialogComponent,
    ShopifySyncDialogComponent,
    ShopifyAuditLogDialogComponent
  ],
  imports: [
    DiscountManagementRoutingModule,
    SharedModule
  ]
})
export class DiscountManagementModule { }
